import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        municipalities: false
      },
      options: {
        municipalities: []
      },
      selected: {
        municipality: ''
      },
      editable: {
        municipality: ''
      }
    }
  },

  watch: {
    'selected.province' (province) {
      if (province?.id) {
        this.getMunicipalities(this, '', province.id).finally(() => {
          if (this.editable.municipality) {
            this.selected.municipality = QUERY.find(this.options.municipalities, {
              id: this.editable.municipality
            }) || ''
            this.editable.municipality = ''
          }
        })
      } else {
        this.selected.municipality = ''
        this.options.municipalities = []
      }
    }
  },

  methods: {

    async getMunicipalities (context, search = '', province = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.municipality
      const fetching = context.fetching?.municipalities
      const options = context.options?.municipalities

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.municipalities = true
      context.selected.municipality = ''

      const filters = {
        filter_text: search,
        province_id: province
      }

      return await SSharedList.getMunicipalities(filters).then(
        ({ data }) => {
          context.options.municipalities = data
        }
      ).catch(() => {
        context.options.municipalities = []
      }).finally(() => {
        context.fetching.municipalities = false
      })
    },

    async searchMunicipalities (search, loading) {
      this.searchMunicipalitiesProvider(this, search, loading)
    },

    searchMunicipalitiesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.municipalities, {
          keys: ['municipality_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            province_id: selected.province?.id || ''
          }

          SSharedList.getMunicipalities(filters).then(
            ({ data }) => {
              options.municipalities = data
            }
          ).catch(() => {
            options.municipalities = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
